module.exports = __webpack_public_path__ + "static/team-b80bec4ce5f53a4978a23814e865a764.jpg";